
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#383E93","fill-rule":"evenodd","d":"M18.8 7.731a5.823 5.823 0 00-1.017-2.055 6.276 6.276 0 00-1.685-1.492 6.987 6.987 0 00-1.73-.747c-.465-.126-.742-.072-1.021-.072H6.654c-.182 0-.363 0-.828.116-.465.115-1.213.33-1.882.695-.67.366-1.26.884-1.728 1.496A5.91 5.91 0 001.2 7.732a5.901 5.901 0 00.587 4.466 5.686 5.686 0 001.517 1.714c.614.457 1.323.78 1.896.981.574.201 1.012.28 1.453.28h6.694c.44 0 .879-.079 1.452-.28.574-.2 1.283-.524 1.897-.981a5.692 5.692 0 001.517-1.715 5.901 5.901 0 00.587-4.466zm-6.51 2.972a5.623 5.623 0 01-.965 1.96 5.616 5.616 0 01-1.641 1.44 5.613 5.613 0 01-4.248.558 5.612 5.612 0 01-3.4-2.607 5.611 5.611 0 01-.558-4.248 5.612 5.612 0 012.607-3.4 5.613 5.613 0 014.248-.558c.71.19 1.376.518 1.96.965a5.61 5.61 0 011.44 1.642 5.61 5.61 0 01.558 4.248z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#383E93","fill-rule":"evenodd","d":"M4.682 7.214a3.007 3.007 0 00-.785 2.022 3.008 3.008 0 001.665 2.686V6.55c-.332.166-.63.39-.88.664zM9.099 7.2a3.032 3.032 0 00-.894-.663v5.4a3.008 3.008 0 001.693-2.7A3.006 3.006 0 009.099 7.2z","clip-rule":"evenodd"}})])
          )
        }
      }
    